// FAQ.js
import React from 'react';
import AskQuestion from './AskQuestion';
import ViewAnswer from './ViewAnswer';


function Faq() {
  return (
    <div>
      <AskQuestion/>
      <ViewAnswer />
    </div>
  );
}

export default Faq;
